import { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  getPublicNavLayout,
  isActiveNavPath,
  resolvePublicNavDate,
  type PublicNavLink,
} from "../config/publicNavLinks";

function renderLink(
  { label, to }: PublicNavLink,
  pathname: string,
  className: string,
  onNavigate?: () => void,
) {
  return (
    <Link
      key={to}
      className={isActiveNavPath(pathname, to) ? "active-nav-link" : className}
      to={to}
      onClick={onNavigate}
    >
      {label}
    </Link>
  );
}

function usePublicNavDate() {
  const [searchParams] = useSearchParams();
  const navSeason = searchParams.get("navSeason");
  const navDate = searchParams.get("navDate");

  return useMemo(() => resolvePublicNavDate(), [navSeason, navDate]);
}

export function PublicNavMainLinks({
  pathname,
  onNavigate,
}: {
  pathname: string;
  onNavigate?: () => void;
}) {
  const navDate = usePublicNavDate();
  const { mainLinks } = getPublicNavLayout(navDate);

  return (
    <>
      {mainLinks.map((link) =>
        renderLink(link, pathname, "nav-link-desktop", onNavigate),
      )}
    </>
  );
}

export function PublicNavMoreLinks({
  pathname,
  onNavigate,
}: {
  pathname: string;
  onNavigate?: () => void;
}) {
  const navDate = usePublicNavDate();
  const { moreLinks } = getPublicNavLayout(navDate);

  return (
    <>
      {moreLinks.map((link) => (
        <li key={link.to}>
          {renderLink(link, pathname, "nav-link-desktop", onNavigate)}
        </li>
      ))}
    </>
  );
}

export function PublicNavHamburgerLinks({
  pathname,
  onNavigate,
}: {
  pathname: string;
  onNavigate?: () => void;
}) {
  const navDate = usePublicNavDate();
  const { hamburgerLinks } = getPublicNavLayout(navDate);

  return (
    <>
      {hamburgerLinks.map((link) =>
        renderLink(link, pathname, "nav-link", onNavigate),
      )}
    </>
  );
}
